// Edika — English string fixups for hardcoded / theme-setting labels.
//
// A handful of UI labels are hardcoded in Liquid or come from theme settings
// (not locale-aware), so Shopify's translation system can't reach them. Langify
// swapped them client-side; this restores that for English after Langify is off.
// Runs ONLY on /en/ pages. Exact full-node matches (dict) + in-node substring
// patterns (regex). Idempotent; safe to re-run. Extend the dict as QA finds more.
(function () {
  if (!/^\/en(\/|$)/i.test(window.location.pathname)) return; // English only

  // Exact match: swap a text node only when its trimmed text equals the key.
  var dict = {
    // coffee-profile.liquid
    "Acidité": "Acidity", "Doux": "Mild", "Acide": "Acidic",
    "Corps": "Body", "Léger": "Light", "Plein": "Full",
    "Torréfaction": "Roast", "Foncé": "Dark",
    "Niveau de cafféine": "Caffeine level", "Corcé": "Bold",
    // grind label + options (settings.grind_size_label / grind_sizes)
    "Mouture": "Grind",
    "En grains": "Whole beans",
    "Cold brew": "Cold brew",
    "French press (type Bodum)": "French press (Bodum type)",
    "Chemex": "Chemex",
    "Pour-over plat (type Kalita)": "Flat pour-over (Kalita type)",
    "Pour-over cône (type V60)": "Cone pour-over (V60 type)",
    "Percolateur": "Percolator",
    "Aeropress": "Aeropress",
    "Moka pot": "Moka pot",
    "Espresso avec filtre pressurisé": "Espresso with pressurized filter",
    "Espresso automatique (type JURA)": "Automatic espresso (JURA type)",
    "Espresso manuelle (type LELIT)": "Manual espresso (LELIT type)",
    "Café turc": "Turkish coffee",
    // specs-table.liquid
    "Réglages et possibilités de programmation": "Settings and programming options",
    "Design et matériaux": "Design and materials",
    "Technologies standard de commande et de programmation": "Operating and programming standards",
    "Spécialités de café": "Coffee specialities",
    "Standards énergétiques": "Energy standards",
    "Durabilité": "Sustainability",
    "Avantages Spécifiques": "Specific benefits",
    "Matériel fourni": "Equipment provided",
    "Caractéristiques": "Specifications",
    "Écoulements": "Dispensing",
    "Performance quotidienne recommandée et domaines d'utilisation": "Recommended daily output and areas of use",
    "Quelques chiffres": "Key figures",
    "Distinctions": "Awards",
    "Commande": "Controls",
    "STANDARDS D'HYGIÈNE": "HYGIENE STANDARDS",
    // free-coffee block (settings.free_coffee_title / _text + hardcoded tag in main-product.liquid)
    "Choisissez votre Kg de café gratuit": "Choose your free kg of coffee",
    "À l’achat de toutes nos machines, nous offrons 1kg de café Touché": "With the purchase of any of our machines, we offer 1kg of Touché coffee",
    "Gratuit": "Free",
    // product / cart / account / misc
    "Accueil": "Home", // breadcrumbs.liquid home crumb (hardcoded, site-wide)
    "Lire la vidéo": "Watch the video",
    "Termes et conditions": "Terms and conditions",
    "Parler à un conseiller": "Talk to an advisor",
    "Parlez à un conseiller": "Talk to an advisor",
    "M'avertir lors du retour en stock": "Notify me when back in stock",
    "Voir plus de produits": "View more products",
    "Voir plus d'options": "View more options",
    "Voir plus de caractéristiques": "View more specifications",
    "Voir moins de caractéristiques": "View less specifications",
    "Où trouver votre numéro de série?": "Where to find your serial number?",
    "Modifier les informations": "Edit information",
    "Date de la commande:": "Order date:",
    "Voir les détails": "View details",
    "Réinitialiser son mot de passe": "Reset your password",
    "Créer un compte": "Create an account",
    "Veuillez saisir un code postal valide.": "Please enter a valid postal code.",
    "Habituellement prête en 24 heures": "Usually ready in 24 hours",
    "Afficher les informations de la boutique": "View store information",
    // Boost filter titles (Boost-rendered; caught via MutationObserver)
    "Marque": "Brand",
    "Type de produit": "Product type",
    "Prix ($)": "Price ($)",
    "Disponibilité": "Availability",
    "Type de bouilloire": "Boiler type",
    "Taille du groupe": "Group size",
    "Hauteur (cm)": "Height (cm)",
    "Largeur (cm)": "Width (cm)",
    "Profondeur (cm)": "Depth (cm)",
    "Type de meules": "Burr type",
    "Couleur": "Color",
    "Type de café": "Coffee type",
    "Trier par": "Sort by",
    // Boost filter common values
    "Noir": "Black",
    "Blanc": "White",
    "Gris": "Grey",
    "Rouge": "Red",
    "En stock": "In stock",
    "En Stock": "In stock",
    "En rupture de stock": "Out of stock",
    "Plates": "Flat",
    "Coniques": "Conical",
    "Décaféiné": "Decaffeinated"
  };

  // In-node substring patterns (nodes that contain a dynamic part, e.g. an address).
  var patterns = [
    [/Service de retrait disponible à/g, "Pickup available at"]
  ];

  function swapText(node) {
    var t = node.nodeValue, trimmed = t.trim();
    if (dict.hasOwnProperty(trimmed)) { node.nodeValue = t.replace(trimmed, dict[trimmed]); return; }
    var updated = t;
    for (var i = 0; i < patterns.length; i++) updated = updated.replace(patterns[i][0], patterns[i][1]);
    if (updated !== t) node.nodeValue = updated;
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { swapText(root); return; }
    if (root.nodeType !== 1) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false), n;
    while ((n = w.nextNode())) swapText(n);
  }

  function run() { walk(document.body); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
  document.addEventListener("shopify:section:load", run);

  // Only process newly-added nodes (cart drawer, AJAX, recommendations) — not the whole page.
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) walk(added[j]);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
